<template>
    <div class="card mb-3">
        <div class="card-body">
            <router-link :to="{name: 'orders.create'}" class="btn btn-primary ml-2" v-if="$store.state.role == 'admin'">ایجاد سفارش گروهی</router-link>
            <button class="btn btn-info" data-toggle="collapse" data-target="#advanced-search">جستجوی پیشرفته</button>
            <div id="advanced-search" class="card collapse mt-3">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-1">
                            <label for="order-id">شناسه</label>
                            <input type="tel" id="order-id" class="form-control ltr-input" v-model="orderId" v-mask="'######'">
                        </div>
                        <div class="col-md-2">
                            <label for="national-code">شناسه ملی / کد ملی</label>
                            <input type="tel" id="national-code" class="form-control ltr-input" v-model="nationalCode" v-mask="'###########'">
                        </div>
                        <div class="col-md-2">
                            <label for="postal-code">کد پستی</label>
                            <input type="tel" id="postal-code" class="form-control ltr-input" v-model="postalCode" v-mask="'##########'">
                        </div>
                        <div class="col-md-3" style="margin-top: 29px">
                            <button class="btn btn-success ml-2" v-on:click="advancedSearch">جستجو</button>
                            <button class="btn btn-danger" v-on:click="removeFilter" v-if="isAdvanced">حذف فیلتر</button>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :key="dataTableKey" :rows="rows" v-if="rows.length" :count="count" :url="'Orders/Search'" :operations="['orders',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}]" :shippings="shippings" :postedData="postedData" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            columns: [
                {
                    title: 'شناسه',
                    field: 'orderId'
                },
                {
                    title: 'نام',
                    field: 'fullName'
                },
                {
                    title: 'کد ملی / شناسه ملی',
                    field: 'nationalCode'
                },
                {
                    title: 'وضعیت سفارش',
                    field: 'statusTitle'
                },
                {
                    title: 'نوع سفارش',
                    field: 'orderType'
                },
                {
                    title: 'پرداخت',
                    field: 'paymentStatusTitle'
                },
                {
                    title: 'مبلغ',
                    field: 'amount'
                },
                {
                    title: 'تاریخ',
                    field: 'createdAt'
                },
                {
                    title: 'ساعت',
                    field: 'createdAtTime'
                },
                {
                    title: 'نوع ارسال',
                    field: 'shippingTitle'
                }
            ],
            shippings: {},
            rows: [],
            showLoading: true,
            count: 0,
            isAdvanced: false,
            dataTableKey: 0,
            postedData: {},
            postalCode: '',
            orderId: '',
            nationalCode: ''
        }
    },
    methods: {
        async getData(){
            await this.$api.get('Shipping').then(({data}) => {
                data.result.map(shipping => {
                    this.shippings[shipping.shippingId] = shipping.title;
                });
            });
            this.$api.post('Orders/Search',{page: 1,perPage: 10}).then(({data}) => {
                if(data.status){
                    this.rows = [];
                    data.result.list.map(order => {
                        this.rows.push({
                            ...order,
                            fullName: order.firstName + ' ' + order.lastName,
                            amount: new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.amount) + ' ریال',
                            shipping: this.shippings[order.shippingId]
                        });
                    });
                    this.count = data.result.count;
                    this.rows.operations = ['orders',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
                    this.dataTableKey += 1;
                }
                this.showLoading = false;
            });
        },
        removeFilter(){
            this.showLoading = true;
            this.isAdvanced = false;
            this.postalCode = '';
            this.getData();
        },
        advancedSearch(){
            this.showLoading = true;
            this.postedData = {
                postalCode: this.postalCode
            };
            this.$api.post('Orders/Search',{page: 1,perPage: 10,...this.postedData}).then(({data}) => {
                if(data.status){
                    this.rows = [];
                    data.result.list.map(order => {
                        this.rows.push({
                            ...order,
                            fullName: order.firstName + ' ' + order.lastName,
                            amount: new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.amount) + ' ریال',
                            shipping: this.shippings[order.shippingId]
                        });
                    });
                    this.count = data.result.count;
                    this.rows.operations = ['orders',{show: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
                    this.dataTableKey += 1;
                }
            }).finally(() => {
                this.showLoading = false;
                this.isAdvanced = true;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>